import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  OnInit,
  NgZone,
  Inject,
  Component,
  ViewChild,
  OnDestroy,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SnPlayerState } from '../../enums';
import { ISnPlayer } from '../../interfaces';

@Component({
  selector: 'sn-player-play-control',
  templateUrl: './player-play.control.html',
  styleUrls: ['./player-play.control.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-player__play-control',
  },
})
export class SnPlayerPlayControl implements OnInit, OnDestroy {
  @ViewChild('pauseButton', { static: true })
  private readonly _pauseButtonRef: ElementRef<HTMLElement>;

  @ViewChild('playButton', { static: true })
  private readonly _playButtonRef: ElementRef<HTMLElement>;

  @ViewChild('replayButton', { static: true })
  private readonly _replayButtonRef: ElementRef<HTMLElement>;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _ngZone: NgZone,
    @Inject('SN_PLAYER') private readonly _player: ISnPlayer,
  ) {}

  public ngOnInit(): void {
    this._ngZone.runOutsideAngular(() => {
      this._player.state$.pipe(takeUntil(this._destroy$)).subscribe((state) => {
        switch (state) {
          case SnPlayerState.Playing: {
            this._pauseButtonRef.nativeElement.classList.remove('display-none');
            this._playButtonRef.nativeElement.classList.add('display-none');
            this._replayButtonRef.nativeElement.classList.add('display-none');
            break;
          }
          case SnPlayerState.Ended: {
            this._pauseButtonRef.nativeElement.classList.add('display-none');
            this._playButtonRef.nativeElement.classList.add('display-none');
            this._replayButtonRef.nativeElement.classList.remove('display-none');
            break;
          }
          default: {
            this._pauseButtonRef.nativeElement.classList.add('display-none');
            this._playButtonRef.nativeElement.classList.remove('display-none');
            this._replayButtonRef.nativeElement.classList.add('display-none');
            break;
          }
        }
      });
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public play(): void {
    this._player.play();
  }

  public pause(): void {
    this._player.pause();
  }
}
